import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  /**
   * Fetching messages work by fetching using offset in the database and fetching max 5 messages so we store smallestMessageId &  biggestMessageId to know last fetchs
   * beforeFetching uses smallest and afterMessageFetching uses biggest
   *
   */
  constructor(
    private auth: AuthServiceService,
    private local: LocalServiceService
  ) {
  }
  private smallestMessageId: any = null; //this is the smallest message Id we have seen used as offset to fetch older messages since all messages are not fetched at once
  private biggestMessageId: any = null; //same for this
  private biggestChatLastMessageId: any = null;
  private chatTotalUnreadCount = new BehaviorSubject<number>(0); //contains the total unread messages count
  private chattingNowSubject = new BehaviorSubject<Set<any>>(new Set()); //this is used to indicated who is typing right now
  private seenMesssage = new Set(); //used to controll messages that may be duplicated when fetched

  public currentChatMessages = new BehaviorSubject<any[]>([]); //messages of the current chat
  public chats = new BehaviorSubject<any[]>([]); //current chats the user has talked to
  public blockeUsers = new BehaviorSubject<any[]>([]); //blocked users
  public isCurrentBiz = false; //if current chat is biz
  public chatTotalUnreadCount$ = this.chatTotalUnreadCount.asObservable();
  public afterSubject = new Subject(); //this is used to notify that aftermessages are fetch...used for things like auto scroll when new messages are sent

  public chattingNowObservalbe = this.chattingNowSubject.asObservable();

  getTotalUnreadMessagesCount() {
    return this.chatTotalUnreadCount.value; //total unread count
  }

  public getBlockedList() {
    this.auth.get_my_blocks().subscribe((data: any) => {
      this.blockeUsers.next(data.data);
    });
  }

  public unBlockUser(chatId, isBiz = false) {
    this.auth.unblock_user(chatId, isBiz).subscribe((_) => {
      this.getBlockedList();
    });
  }

  public blockUser(chatId, isBiz) {
    this.auth.block_user(chatId, isBiz).subscribe((_) => {
      this.getBlockedList();
    });
  }

  resetTotalUnreadCount() {
    this.chatTotalUnreadCount.next(0);
  }

  //Makes all the messages of a given chatId to seen also changes the stored value of the unreadCount of the chat
  public makeChatMessagesSeen(chatId): Promise<undefined> | undefined {
    if (!chatId) {
      return;
    }
    return new Promise((res, rej) => {
      const c = this.chats.value.find((chat) => chat.chatId == chatId);
      if (c) {
        // console.log('Chat found ', { c });
        this.chatTotalUnreadCount.next(
          this.chatTotalUnreadCount.value - c['unreadCount']
        );

        c['unreadCount'] = 0;
        // console.log('Chat now is', { c });
      } else {
        // console.log('Message is from a new chat');
      }
      const tmp = this.chats.value;
      this.chats.next([]);
      this.chats.next([...tmp]);
      this.auth.make_chat_messages_seen(chatId, this.isCurrentBiz).subscribe({
        next: () => {
          res(undefined);
          this.updateTotalUnreadMessagesCount();
        },
        error: (err) => rej(err),
      });
    });
  }

  //This is used to decide is main ai is shown or not shown in chats
  public showMainAI: boolean = false;

  private seenLastMessages = new Set();

  //fetchs the current chats of the user seen in chat list
  public getAllChats() {
    this.auth.get_chats_with_count(null).subscribe({
      next: async (data: any) => {
        if (data.success) {
          this.showMainAI = data.addMainAIInMyChat;
          // console.log({ data });
          // console.log(this.showMainAI);
          for (const chat of data.data) {
            if (chat['profileCharacterImageFile']) {
              chat['profileCharacterImageFile'] =
                environment.ImageUrl + chat['profileCharacterImageFile'];
            }
            const lastMessageID = chat['lastMessageId'];
            if (this.biggestChatLastMessageId) {
              this.biggestChatLastMessageId = Math.max(
                this.biggestChatLastMessageId,
                lastMessageID
              );
            } else {
              this.biggestChatLastMessageId = lastMessageID;
            }
            if (!this.seenLastMessages.has(lastMessageID)) {
              this.seenLastMessages.add(lastMessageID);
              if (
                !chat['isLastMessageSeen'] &&
                chat['unreadCount'] &&
                !chat['isArchived'] // &&
              ) {
                try {
                  await this.playNotification();
                } catch (e) {
                  console.warn(e);
                }
              }
            }
          }

          this.chats.next(data.data);
        }
      },
      error: console.warn,
    });
  }

  public isDateToday(i): boolean {
    // // console.log('checking if message is today');
    return (
      this.currentChatDatesMap[i] == this.getDateOnly(new Date().toISOString())
    );
  }
  private getDateOnly(isoString: string): string {
    const date = new Date(isoString);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = String(day).padStart(2, '0');
    const formattedMonth = String(month).padStart(2, '0');

    const rv = `${formattedDay}/${formattedMonth}/${year}`;

    // console.log(`Formatted date for ${isoString} is ${rv}`);
    return rv;
  }

  private getFormatedDate(isoString) {
    const date = new Date(isoString);
    const hours = date.getUTCHours(); // Get hours (UTC)
    const minutes = date.getUTCMinutes(); // Get minutes (UTC)
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    // Format minutes to always show two digits
    return `${hours}:${minutes
      .toString()
      .padStart(2, '0')} ${day}/${month}/${year}`;
  }

  /**The next 2 functions will be removed currently only used to avoid errors */
  public getChatLastSeenForId(id): string | null {
    const rvObj = this.chats.value.find(
      (chat: any) => chat.chatId == id
    ) as any;

    if (!rvObj) {
      return null;
    }
    return 'Last seen at ' + this.getFormatedDate(rvObj['lastSeenTime']);
  }

  public getProductDataForChat(id) {
    const rvObj = this.chats.value.find(
      (chat: any) => chat.chatId == id
    ) as any;

    if (!rvObj) {
      return null;
    }
    return rvObj['lastMesssageAboutProduct'];
  }

  /**
   * Get unreadMessagesCount and notify
   */
  public updateTotalUnreadMessagesCount() {
    this.auth.get_total_unread_message_count().subscribe({
      next: (data: any) => {
        if (data.success) {
          this.chatTotalUnreadCount.next(data.data);
        }
      },
      error: console.error,
    });
  }

  //When a chat types in other computers the socket service notifies us using the setTyping function
  //then this map is changed to contain that user for 500ms then removed
  //chattingNow contains the list of people typing to us

  public setTyping(chatId) {
    if (!chatId) {
      console.warn('Invalid chat id given to typing');
      return;
    }

    this.chattingNowSubject.value.add(chatId + '');
    this.chattingNowSubject.next(new Set([...this.chattingNowSubject.value]));

    setTimeout(() => {
      this.chattingNowSubject.value.delete(chatId + ''); //after 500ms remove from typing
      this.chattingNowSubject.next(new Set(this.chattingNowSubject.value));
    }, 500);
  }

  //Set the current chat
  setCurrentChat(chatId, isBiz = false) {
    // // console.log(`Setting current chat to`, chatId);
    this.currentChatMessages.next([]); //clear old messages
    this.currentChatId = chatId;
    this.smallestMessageId = null; //reset smallest message id
    this.biggestMessageId = null; //reset biggest message id
    this.isCurrentBiz = isBiz;
    this.seenMesssage = new Set(); //used to controll duplicate messages
    return this.getAfterMessages(); //fetch the last messages(5)
  }
  currentChatId: any = null;
  private async getChatMessagesOf(
    chatId,
    { before = null, after = null, init = 'None', fetchOnly = false }
  ): Promise<any> {
    // console.log('Fetch Chat Message init by ' + init);
    return new Promise((res, rej) => {
      if (!this.auth) {
        res([]);
      }
      this.auth
        ?.fetch_chat_message(chatId, {
          before,
          after,
          isFromBiz: this.isCurrentBiz,
        })
        .subscribe({
          next: (data: any) => {
            if (data.success) {
              for (const msg of data.data) {
                if (msg.imageContent) {
                  msg.imageContent = environment.ImageUrl + msg.imageContent;
                }
                const id = (msg as any).id;
                if (this.smallestMessageId) {
                  this.smallestMessageId = Math.min(this.smallestMessageId, id);
                } else {
                  this.smallestMessageId = id;
                }

                if (this.biggestMessageId) {
                  this.biggestMessageId = Math.max(this.biggestMessageId, id);
                } else {
                  this.biggestMessageId = id;
                }
              }
            }

            res(data.data);
          },
          error: rej,
        });
    });
  }

  //just the sendMessage Wrapper
  public sendMessage(args) {
    return this.auth.send_message(args, this.isCurrentBiz);
  }

  //Fetch Messages greater older than smallestMessageId, this is called when scrolling upwards
  //seenMessage is used to control duplicate messages that might come from being added
  public async getBeforeMesssage() {
    //  // console.log('getting before messages')
    if (!this.currentChatId) {
      // console.log('currently talking to is null');
      return;
    }
    const newMessages = await this.getChatMessagesOf(this.currentChatId, {
      before: this.smallestMessageId,
      init: 'Before',
    });
    const nM: any = [];
    for (const msg of newMessages) {
      if (!this.seenMesssage.has(msg.id)) {
        nM.push(msg);
      }
      this.seenMesssage.add(msg.id);
    }

    this.currentChatMessages.next([...nM, ...this.currentChatMessages.value]);
    this.addDatesInTheMiddle();
  }

  private async playNotification() {
    const audio = new Audio('./assets/sounds/notification_2.mp3');
    await audio.play();
  }

  /**
   *  Days are added in chats using the code below
   *  Works by getting the unqiue ordered datees messages have
   *  and adding them in array
   *  the templat them compare the array's date and message if not seen then it's added and visible
   */
  public currentChatDatesMap = new Map();
  private addDatesInTheMiddle() {
    // // console.log('Adding dates in the middle');
    this.currentChatDatesMap = new Map(); //refresh it
    let nowDate = null;
    for (let i = 0; i < this.currentChatMessages.value.length; i++) {
      const message = this.currentChatMessages.value[i];
      const msgDate = this.getDateOnly(message.sendTime);
      if (msgDate != nowDate) {
        nowDate = msgDate;

        this.currentChatDatesMap[i] = nowDate;
        if (this.isDateToday(i)) {
          this.currentChatDatesMap[i] = 'Today';
        }
      }
    }
    // // console.log('Current Dates Map', this.currentChatDatesMap);
  }

  //Fetches messages older than biggestMessageId, also checks if duplicated are found using seenMessage
  public async getAfterMessages(fetchOnly = false) {
    if (!this.currentChatId) {
      return;
    }
    const newMessagesRaw = await this.getChatMessagesOf(this.currentChatId, {
      after: this.biggestMessageId,
      init: 'After',
      fetchOnly,
    });

    const newMessages: any = [];
    for (const msg of newMessagesRaw) {
      if (!this.seenMesssage.has(msg.id)) {
        this.seenMesssage.add(msg.id);
        newMessages.push(msg);
      }
    }

    this.currentChatMessages.next([
      ...this.currentChatMessages.value,
      ...newMessages,
    ]);
    this.addDatesInTheMiddle();

    if (newMessages.length) {
      setTimeout(() => {
        this.afterSubject.next(fetchOnly);
      }, 600);
    }
  }
}
